module.exports = __webpack_public_path__ + "static/media/lab3-first-interactive-web-page.23244b3a.png";